module.exports = __webpack_public_path__ + "img/20210610-IMG_06082.6b32ea25.jpg";